import Head from 'next/head';

type HeadProps = {
  title?: string;
  children?: React.ReactNode;
};

const HeadEl = ({ title = 'Coverstories', children }: HeadProps) => {
  return (
    <>
      <Head>
        <link rel="dns-prefetch" href="//coverstories.co" />
        <link rel="dns-prefetch" href="//api.coverstori.es" />
        <link rel="dns-prefetch" href="//analytics.coverstori.es" />
        <link rel="dns-prefetch" href="//youtube.com" />
        <link rel="dns-prefetch" href="//i.ytimg.com" />
        <title>{title}</title>

        {children}
      </Head>
    </>
  );
};

export default HeadEl;
